import React from 'react';

interface InlinePageSectionProps {
    fillRatio: number;
    parentHeight: number;
    children: React.ReactNode;
}

export default function InlinePageSection({ children }: InlinePageSectionProps) {
    return <div className="inline-page-section">{children}</div>;
}
